// extracted by mini-css-extract-plugin
export default {"root":"SectionRecommendsMaybe_root__heXYH","title":"SectionRecommendsMaybe_title__5VOlm","listingsGrid":"SectionRecommendsMaybe_listingsGrid__YsohF"};